function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Accordion from '@engine/components/presentational/base/accordion';
import Error from '@engine/components/presentational/base/error';
import PanelStatus from '@engine/components/presentational/base/panel-status';
import React from 'react';
import { connect } from 'react-redux';
import { updateShowWpfFields } from '@engine/actions/creators/show_wpf_fields';
var USER_INPUT_DELAY = 800;
var STATUS_MESSAGE_EXIT_DELAY = 5000;

var ShowWpfFields = /*#__PURE__*/function (_React$Component) {
  _inherits(ShowWpfFields, _React$Component);

  var _super = _createSuper(ShowWpfFields);

  function ShowWpfFields(props) {
    var _this;

    _classCallCheck(this, ShowWpfFields);

    _this = _super.call(this, props);
    _this.state = {
      showSuccessfulStatus: false,
      supportedFields: {}
    };
    _this.userInputTimeout = null;
    _this.statusMessageTimeout = null;
    return _this;
  }

  _createClass(ShowWpfFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setSupportedFields();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isSaved !== this.props.isSaved) {
        this.clearSuccessfulStatus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          hasError = _this$props.hasError,
          isSaved = _this$props.isSaved,
          isSaving = _this$props.isSaving,
          message = _this$props.message;
      var _this$state = this.state,
          showSuccessfulStatus = _this$state.showSuccessfulStatus,
          supportedFields = _this$state.supportedFields;
      return React.createElement(Accordion, {
        icon: "user",
        title: I18n.t('javascript.merchants.form.show_wpf_fields'),
        header: React.createElement(PanelStatus, {
          hasError: hasError,
          isSaved: isSaved,
          isSaving: isSaving,
          showSuccessfulStatus: showSuccessfulStatus
        })
      }, hasError && React.createElement(Error, {
        className: "alert-slim"
      }, message, this.errors()), Object.keys(supportedFields).map(function (field) {
        return React.createElement("div", {
          key: field,
          className: "checkbox"
        }, React.createElement("label", {
          htmlFor: "feature_".concat(field)
        }, React.createElement("input", {
          type: "checkbox",
          name: "features[]",
          id: "feature_".concat(field),
          checked: supportedFields[field],
          onChange: function onChange() {
            return _this2.onChange(field);
          }
        }), I18n.t("javascript.merchants.form.".concat(field))));
      }));
    }
  }, {
    key: "setSupportedFields",
    value: function setSupportedFields() {
      this.setState({
        supportedFields: this.props.initialFields
      });
    }
  }, {
    key: "errors",
    value: function errors() {
      var errors = this.props.errors;

      if (Array.isArray(errors) && errors.length) {
        var _errors = _slicedToArray(errors, 2),
            field = _errors[0],
            validation = _errors[1];

        return React.createElement(React.Fragment, null, React.createElement("br", null), field, ": ", validation);
      }
    }
  }, {
    key: "clearSuccessfulStatus",
    value: function clearSuccessfulStatus() {
      var _this3 = this;

      if (this.statusMessageTimeout) {
        return;
      }

      this.setState({
        showSuccessfulStatus: true
      });
      this.statusMessageTimeout = setTimeout(function () {
        _this3.setState({
          showSuccessfulStatus: false
        });

        _this3.statusMessageTimeout = null;
      }, STATUS_MESSAGE_EXIT_DELAY);
    }
  }, {
    key: "updateSupportedFields",
    value: function updateSupportedFields() {
      var _this4 = this;

      this.userInputTimeout = setTimeout(function () {
        var supportedFields = _this4.state.supportedFields;
        var filteredSupportedFields = Object.keys(supportedFields).filter(function (selectedField) {
          return supportedFields[selectedField];
        });

        _this4.props.updateShowWpfFields(_this4.props.url, filteredSupportedFields);
      }, USER_INPUT_DELAY);
    }
  }, {
    key: "onChange",
    value: function onChange(field) {
      clearTimeout(this.userInputTimeout);
      clearTimeout(this.statusMessageTimeout);
      this.setState({
        showSuccessfulStatus: false
      });
      this.statusMessageTimeout = null;
      this.setState(function (prevState) {
        return {
          supportedFields: _objectSpread(_objectSpread({}, prevState.supportedFields), {}, _defineProperty({}, field, !prevState.supportedFields[field]))
        };
      });
      this.updateSupportedFields();
    }
  }]);

  return ShowWpfFields;
}(React.Component);

export default connect(function (state) {
  return {
    errors: state.showWpfFields.errors,
    hasError: state.showWpfFields.hasError,
    isSaved: state.showWpfFields.isSaved,
    isSaving: state.showWpfFields.isSaving,
    message: state.showWpfFields.message
  };
}, {
  updateShowWpfFields: updateShowWpfFields
})(ShowWpfFields);